/**
 * @generated SignedSource<<6495e1cb082272fcd412e8c4a7834e5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WAFileSettings_file$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
  readonly " $fragmentType": "WAFileSettings_file";
};
export type WAFileSettings_file$key = {
  readonly " $data"?: WAFileSettings_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"WAFileSettings_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WAFileSettings_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIcon_File"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "da39366e7cef463af8c2739f6b5edff3";

export default node;
